// Shared store modules for monorepo
// Import all store modules
import cart from './cart.js';
import token from './token.js';
import state from './state.js';
import geo from './geo.js';
import hours from './hours.js';

// Export individual modules for named imports
export { cart, token, state, geo, hours };

// Create a function to configure the complete store
export const createVuexStore = () => {
  return {
    modules: {
      cart,
      token,
      state,
      geo,
      hours,
    },
  };
};

// For apps that want specific modules only
export const createCartStore = () => {
  return {
    modules: { cart, token },
  };
};

export const createBridgeStore = () => {
  return {
    modules: { token, state },
  };
};

// Default export with all modules for convenience
export default {
  cart,
  token,
  state,
  geo,
  hours,
  createCartStore,
  createBridgeStore
};
